"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Delete_1 = __importDefault(require("@material-ui/icons/Delete"));
const Edit_1 = __importDefault(require("@material-ui/icons/Edit"));
const FileCopy_1 = __importDefault(require("@material-ui/icons/FileCopy"));
function createDefaultActions({ onEdit = () => null, onClone, onDelete = () => null, }) {
    return [
        onEdit && {
            name: 'edit',
            label: 'View & Edit',
            Icon: Edit_1.default,
            onClick: onEdit,
        },
        onClone && {
            name: 'clone',
            label: 'Clone',
            Icon: FileCopy_1.default,
            onClick: onClone,
        },
        { name: 'divider' },
        onDelete && {
            name: 'delete',
            label: 'Delete',
            Icon: Delete_1.default,
            color: 'red',
            onClick: onDelete,
        },
    ].filter((it) => !!it);
}
exports.default = createDefaultActions;
//# sourceMappingURL=defaultActions.js.map